import { makeReducer } from 'shared/helpers/functional'

const toggle = key => state => ({ ...state, [key]: !state[key] })

const initialState = {
  customCrowdModal: {isOpen: false, isListMatch: true},
  thankYouModalOpen: false,
  editSampleSizeModal: {
    isOpen: false,
    projectId: "",
    showWarning: false,
    avModCount: '',
  },
  generateSchedulerLinkModal: {
    isOpen: false,
  },
  generateConfirmationSchedulerLinkModal: {
    isOpen: false,
  },
  previewConferenceLinkModal: {
    isOpen: false,
    languageCountryCode : 'en_us'
  },
  editSurveyIdModal: {
    isOpen: false,
  },
  confirmEditSurveyIdModal: {
    isOpen: false,
  },
  editSampleSizeWarningModal: {
    isOpen: false,
    sampleSize: 0,
    initialSampleSize: 0,
  },
  editInterviewOrModeratorBufferModal: {
    isOpen: false,
    flag:''
  },
  changeTimezoneModal : {
    isOpen: false
  },
  changePasswordModal : {
    isOpen: false
  },
  contactPreferencesModal: {
    isOpen: false,
    userId: ""
  },
  editIncentiveModal: {
    isOpen: false,
    timeSlotId: ""
  },
  creditIncentiveModal: {
    isOpen: false,
    timeSlotId: ""
  }
}

export default makeReducer({
  OPEN_LIST_MATCH_MODAL: (state) => ({
    ...state,
    customCrowdModal: {
      isOpen: true,
      isListMatch: true,
    },
  }),
  OPEN_PVL_MODAL: (state) => ({
    ...state,
    customCrowdModal: {
      isOpen: true,
      isListMatch: false,
    },
  }),
  CLOSE_CUSTOM_CROWD_MODAL: (state) => ({
    ...state,
    customCrowdModal: {
      ...state.customCrowdModal,
      isOpen: false,
    },
  }),
  TOGGLE_THANK_YOU_MODAL: toggle('thankYouModalOpen'),
  SET_SELECTED_SURVEYS: (state, {selectedSurveys}) => ({
    ...state,
  }),
  OPEN_EDIT_SAMPLE_SIZE_MODAL: (state, {payload}) => ({
    ...state,
    editSampleSizeModal: {
      isOpen: true,
      projectId: payload.projectId,
      initialSampleSize: payload.initialSampleSize,
      sampleSize: payload.sampleSize,
      scheduled: payload.scheduled,
      completed: payload.completed,
    },
  }),
  CLOSE_EDIT_SAMPLE_SIZE_MODAL: (state) => ({
    ...state,
    editSampleSizeModal: {
      isOpen: false,
    },
  }),
  OPEN_GENERATE_SCHEDULER_LINK_MODAL: (state) => ({
    ...state,
    generateSchedulerLinkModal: {
      isOpen: true,
    },
  }),
  OPEN_GENERATE_SCHEDULER_LINK_CONFIRMATION_MODAL: (state) => ({
    ...state,
    generateConfirmationSchedulerLinkModal: {
      isOpen: true,
    },
  }),

  OPEN_PREVIEW_CONFERENCE_LINK_MODAL: (state,{payload}) =>
   ({
    ...state,
    previewConferenceLinkModal: {
      isOpen: true,
      languageCountryCode: payload.languageName,
      code: payload.responderLanguage
    },
  }),
    
  CLOSE_GENERATE_SCHEDULER_LINK_MODAL: (state) => ({
    ...state,
    generateSchedulerLinkModal: {
      isOpen: false,
    },
  }),

  CLOSE_CONFIRMATION_GENERATE_SCHEDULER_LINK_MODAL: (state) => ({
    ...state,
    generateConfirmationSchedulerLinkModal: {
      isOpen: false,
    },
  }),

  CLOSE_PREVIEW_CONFERENCE_LINK_MODAL: (state) => ({
    ...state,
    previewConferenceLinkModal: {
      isOpen: false,
    },
  }),

  OPEN_EDIT_SURVEY_ID_MODAL: (state) => ({
    ...state,
    editSurveyIdModal: {
      isOpen: true,
    },
  }),
  
  CLOSE_EDIT_SURVEY_ID_MODAL: (state) => ({
    ...state,
    editSurveyIdModal: {
      isOpen: false,
    },
  }),

 OPEN_EDIT_INTERVIEW_OR_MODERATOR_BUFFER_MODAL: (state, {payload}) => ({
    ...state,
    editInterviewOrModeratorBufferModal: {
      isOpen: true,
      flag: payload.flag
    },
  }),

  CLOSE_EDIT_INTERVIEW_OR_MODERATOR_BUFFER_MODAL: (state) => ({
    ...state,
    editInterviewOrModeratorBufferModal: {
      isOpen: false,
    },
  }),

  OPEN_CONFIRM_EDIT_SURVEY_ID_MODAL: (state,{payload}) => (
    {
    ...state,
    confirmEditSurveyIdModal: {
      isOpen: true,
      editedsurveyId: payload,
    },
    editSurveyIdModal: {
      isOpen: false,
    },
  }
  ),
  
  CLOSE_CONFIRM_EDIT_SURVEY_ID_MODAL: (state) => ({
    ...state,
    confirmEditSurveyIdModal: {
      isOpen: false,
    },
  }),
  
  OPEN_EDIT_SAMPLE_SIZE_WARNING_MODAL: (state, {payload}) => ({
    ...state,
    editSampleSizeWarningModal: {
      isOpen: true,
      sampleSize: payload.sampleSize,
      initialSampleSize: payload.initialSampleSize,
    },
    editSampleSizeModal: {
      isOpen: false,
    },
  }
  ),

  CLOSE_EDIT_SAMPLE_SIZE_WARNING_MODAL: (state) => ({
    ...state,
    editSampleSizeWarningModal: {
      isOpen: false,
    },
    editSampleSizeModal: {
      showWarning: false,
    },
  }),

  GET_AVAILABLE_MODERATORS_COUNT_SUCCESSED: (state, {payload}) => ({
    ...state,
     editSampleSizeModal:{
      isOpen: true,
      isSubmitting:false,
      avModCount:  payload.avModCount,
      showWarning: payload.showWarning,
      showWarningBanner: payload.showWarningBanner,
      projectId: payload.projectId,
      initialSampleSize: payload.initialSampleSize,
      sampleSize: payload.sampleSize,
    },
  }),

  EDIT_SAMPLE_SIZE_WARNING_GO_BACK: (state,{payload}) => ({
    ...state,
    editSampleSizeWarningModal: {
      isOpen: false,
    },
    editSampleSizeModal: {
      isOpen: true,
      initialSampleSize: payload.initialSampleSize,
      sampleSize: payload.sampleSize,
      projectId: payload.id,
      initialSampleSizeBeforeWarning: payload.initialSampleSizeBeforeWarning,
    },
  }),

  OPEN_CHANGE_TIMEZONE_MODAL: (state) => ({
    ...state,
    changeTimezoneModal: {
      isOpen: true,
    },
  }
  ),
  CLOSE_CHANGE_TIMEZONE_MODAL: (state) => ({
    ...state,
    changeTimezoneModal: {
      isOpen: false,
    },
  }
  ),
  OPEN_CHANGE_PASSWORD_MODAL: (state) => ({
    ...state,
    changePasswordModal: {
      isOpen: true,
    },
  }
  ),
  CLOSE_CHANGE_PASSWORD_MODAL: (state) => ({
    ...state,
    changePasswordModal: {
      isOpen: false,
    },
  }
  ),
  OPEN_CONTACT_PREFERENCES_MODAL: (state,{payload}) =>  ({

    ...state,
    contactPreferencesModal: {
      isOpen: true,
      userId: payload
    },
  }
  ),
  CLOSE_CONTACT_PREFERENCES_MODAL: (state) => ({
    ...state,
    contactPreferencesModal: {
      isOpen: false,
    },
  }
  ),
  OPEN_EDIT_INCENTIVE_MODAL: (state, {payload}) => ({
    ...state,
    editIncentiveModal: {
      isOpen: true,
      timeSlotId: payload.timeSlotId,
      initialIncentive: payload.initialIncentive,
      incentive: payload.incentive,
      currency: payload.currency,
    },
  }),
  CLOSE_EDIT_INCENTIVE_MODAL: (state) => ({
    ...state,
    editIncentiveModal: {
      isOpen: false,
    },
  }),
  OPEN_CREDIT_INCENTIVE_MODAL: (state, {payload}) => ({
    ...state,
    creditIncentiveModal: {
      isOpen: true,
      timeSlotId: payload.timeSlotId,
      incentive: payload.incentive,
      currency: payload.currency,
    },
  }),
  CLOSE_CREDIT_INCENTIVE_MODAL: (state) => ({
    ...state,
    creditIncentiveModal: {
      isOpen: false,
    },
  }),
}, initialState)
